import React from 'react';
import { useTranslation } from 'react-i18next';

const WhyChooseUs = () => {
  const { t } = useTranslation();
  const choises = t('choises', { returnObjects: true });

  return (
    <section className="py-20 bg-gray-50 dark:bg-slate-950">
      <div className="container mx-auto px-6 lg:px-20">
        {/* En-tête de section */}
        <div className="text-center">
          <h6 className="text-3xl font-bold text-blue-600 mb-4">{t('titleChoose')}</h6>
          <h3 className="text-4xl font-bold text-black dark:text-gray-100 mb-6">{t('soustitle')}</h3>
          <p className="text-gray-600 dark:text-gray-400 max-w-xl mx-auto">
            "{t('desc')}"
          </p>
        </div>

        {/* Cartes des avantages */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {choises.map((choise, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-950 shadow-md rounded-lg p-6 text-center transition-transform transform hover:scale-105"
            >
              <h1 className="text-5xl font-extrabold text-left mb-4 py-1 text-blue-600">{choise.numero}</h1>
              <h4 className="text-xl font-semibold text-gray-800 dark:text-gray-200 text-left mb-2">{choise.title}</h4>
              <p className="text-gray-600 dark:text-gray-400 text-left mb-4">{choise.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
